import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import { CheckoutBreadcrumb } from '@/core/components'

// Default 3-step flow (Oman). Countries with a different flow (e.g. Taiwan's
// 4-step Customise/Shipping/Billing/Purchase) pass their own `steps` so the
// skeleton stepper matches the loaded one and doesn't jump.
const SKELETON_STEPS = [
    { key: 'customise', label: 'customise' },
    { key: 'shipping', label: 'shipping' },
    { key: 'purchase', label: 'purchase' }
]

type Props = {
    activeIndex?: number
    steps?: { key: string; label: string }[]
}

const CheckoutLayoutSkeleton = ({ activeIndex = 1, steps = SKELETON_STEPS }: Props) => (
    <>
        <CheckoutBreadcrumb steps={steps} activeIndex={activeIndex} sx={{ mt: '40px' }} data-testid="checkout-layout-skeleton-checkout-breadcrumb" />
        <Box
            sx={{
                boxSizing: 'border-box',
                width: '100%',
                maxWidth: 1200,
                mx: 'auto',
                px: { xs: '20px', sm: '30px', lg: '16px' },
                // Match the loaded LayoutGrid top padding (24px) so cards don't
                // jump when the skeleton swaps for real content.
                pt: 3,
                mb: 5
            }}
            data-testid="checkout-layout-skeleton-box-skeleton-1">
            <Box
                sx={{
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 3,
                    '@media (min-width: 1200px)': {
                        display: 'grid',
                        gridTemplateColumns: '770px 370px',
                        gap: '22px',
                        justifyContent: 'center'
                    }
                }}
                data-testid="checkout-layout-skeleton-box-skeleton-2">
                <Stack spacing={3} data-testid="checkout-layout-skeleton-stack-skeleton">
                    <Skeleton variant="rounded" height={200} sx={{ borderRadius: '12px' }} data-testid="checkout-layout-skeleton-skeleton-1" />
                    <Skeleton variant="rounded" height={420} sx={{ borderRadius: '12px' }} data-testid="checkout-layout-skeleton-skeleton-2" />
                </Stack>
                <Skeleton variant="rounded" height={370} sx={{ borderRadius: '12px' }} data-testid="checkout-layout-skeleton-skeleton-3" />
            </Box>
        </Box>
    </>
)

export default CheckoutLayoutSkeleton
